export enum ConfigAction {
    START_ONBOARDING = 'START_ONBOARDING',
    STOP_ONBOARDING = 'STOP_ONBOARDING',
}

export interface ConfigState {
    isOnboarding: boolean
}

